import { h } from 'preact';
import { render } from '@testing-library/preact';
import { expect } from 'chai';
import { MessageStartIcon, severities } from '@oracle/oraclejet-preact/UNSAFE_Message';

describe('Test MessageStartIcon component', () => {
  for (const severity in severities) {
    if (severity === 'none') {
      continue;
    }

    it(`severity ${severity}`, async function () {
      const content = render(
        <MessageStartIcon
          severity={severity as any}
        />
      );

      const icon = content.container.firstElementChild;
      expect(icon).not.null;
    });
  }
});
